package com.eladfinish.bible.contest.screens.main.usecases

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.russhwolf.settings.Settings

class StoredAppVersionUseCase(
    private val settings: Settings,
) {

    fun getStoredAppVersionCode(): Long =
        settings.getLong(SharedPrefsConstants.STORED_VERSION_CODE, 0)

    fun setStoredAppVersionCode(value: Long) {
        settings.putLong(SharedPrefsConstants.STORED_VERSION_CODE, value)
    }

}
